

































































    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '../../lib/util'
    import AbpBase from '../../lib/abpbase'
    import Equipment from '../../store/entities/equipment'
 

     @Component
    export default class CreateEquipment extends AbpBase{
        @Prop({type:Boolean,default:false}) value:boolean;
        user:Equipment=new Equipment();



//获取初始值
    get qarealist(){
      
            return this.$store.state.equipment.qarea;
     }
      //区下面的街道
       get qarealst(){
           return this.$store.state.equipment.qarealst;
       }
       set qarealst(val:number){
            this.$store.commit('equipment/change_qarealst',val);
       }
       //街道的社区
       get sarealst(){
            return this.$store.state.equipment.sarealst;
       }
       set sarealst(val:number){
          this.$store.commit('equipment/change_sarealst',val);           
        
       }
       //社区下的小区
      get carealst(){

            return this.$store.state.equipment.carealst;
       }
       set carealst(val:number){
          this.$store.commit('equipment/change_carealst',val);           
        
       }
       
     QAreaChange(val:number){
     var dt= this.$store.state.equipment.qarea;
        dt.forEach(item=>{
        if(item.id==val){
         this.qarealst=item;
     }
          })
       }
      SAreaChange(val:number){
      
       var dt= this.$store.state.equipment.qarealst.sAreas;
     dt.forEach(item=>{
        if(item.id==val){
         this.sarealst=item;
        }
    })
      }
     CAreaChange(val:number){
 
       var dt= this.$store.state.equipment.sarealst.cAreas;
    dt.forEach(item=>{
    if(item.id==val){
         this.carealst=item;
        }
    })
 }

         
        save(){
            debugger
            (this.$refs.userForm as any).validate(async (valid:boolean)=>{
                if(valid){
                    await this.$store.dispatch({
                        type:'equipment/create',
                        data:this.user
                    });
                    (this.$refs.userForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input',false);
                }
            })
        }
        
       
        cancel(){
            (this.$refs.userForm as any).resetFields();
            this.$emit('input',false);
        }
        visibleChange(value:boolean){
            if(!value){
                this.$emit('input',value);
            }
        } 

       
        userRule={
            areaid:[{type:'number', required: true,message:'请选择小区',trigger: 'change'}],
            name:[{required: true,message:this.L('FieldIsRequired',undefined,this.L('点位名称')),trigger: 'blur'}],
            equipmentNumber:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('设备编号')),trigger: 'blur'}],
            equipmentType:[{type:'number',required:true,message:this.L('FieldIsRequired',undefined,this.L('设备类型')),trigger: 'blur'}]
        }
    }
